import { render, staticRenderFns } from "./si_ticket.vue?vue&type=template&id=8272772e&scoped=true&"
import script from "./si_ticket.vue?vue&type=script&lang=js&"
export * from "./si_ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8272772e",
  null
  
)

export default component.exports